var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBhiBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0181614 108C0.534926 79.55 12.0611 52.3754 32.2183 32.2183C52.8473 11.5893 80.8262 0 110 0C139.174 0 167.153 11.5893 187.782 32.2183C207.939 52.3754 219.465 79.55 219.982 108H137.176C137.177 107.908 137.178 107.816 137.178 107.723C137.178 92.6246 124.938 80.3846 109.839 80.3846C94.74 80.3846 82.5 92.6246 82.5 107.723C82.5 107.816 82.5005 107.908 82.5014 108H0.0181614ZM0 110L82.5934 110C82.5934 110 82.5934 110 82.5934 110L0 110Z",
    fill: "#7B1FA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5051 131.596C88.7733 127.268 83.3595 119.293 82.5934 110H1.11694e-09C-8.77933e-05 129.484 5.17549 148.629 15.0108 165.471C24.8192 182.267 38.8998 196.153 55.8071 205.724L96.5051 131.596Z",
    fill: "#FFD143"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.468 204.4C182.666 194.711 196.102 181.015 205.479 164.624C214.994 147.992 220 129.162 220 110H137.084C136.348 118.934 131.315 126.651 124.057 131.079L166.468 204.4Z",
    fill: "#E91E63"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.313 132.057C118.573 133.978 114.332 135.062 109.839 135.062C105.71 135.062 101.795 134.147 98.2857 132.508L57.5564 206.694C73.9117 215.564 92.2618 220.147 110.891 219.996C129.804 219.843 148.351 214.816 164.743 205.411L122.313 132.057ZM55.6342 205.626L62.245 193.998L55.8071 205.724L55.6342 205.626Z",
    fill: "#009688"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhiBackground);
export default __webpack_public_path__ + "static/media/bhi_background.bb94d7ba.svg";
export { ForwardRef as ReactComponent };